import i18n from '../locales';
import store from '../store';
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import cfdiEscl from '../locales/es-CL/cfdi.json';
import cfdiEsmx from '../locales/es-MX/cfdi.json';
import cfdiEsco from '../locales/es-CO/cfdi.json';
import cfdiEnus from '../locales/en-US/cfdi.json';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import moment from 'moment';
import Container from 'typedi';
import LogService from '../services/LogService';

export default {
  props: ['configs', 'cfdis', 'type', 'route', 'canCreateCFDI', 'onConfirmCallback'],
  name: 'CfdiHandlerModal',
  components: { Multiselect },
  data() {
    return {
      cfdiType: 'T',
      cartaPorteEnabled: false,
      isMainPageBussy: false,
      dataAccess: null,
      cfdi: {
        issuer: null,
        receiver: null,
      },
      issuerList: [],
      receiverList: [],
      cfdiList: [],
      cfdiUseList: [],
      taxRegimeList: [],
      unitList: [],
      itemDataList: [],
      taxObjectList: [],
      paymentMethodList: [],
      paymentFormList: [],
      generalDataExcel: null,
      conceptDataExcel: null,
      validationMessages: [],
      locationsDataExcel: null,
      merchDataExcel: null,
      vehicleDriverDataExcel: null,
      observations: null,
      matchedValue: 0,
      file: null,
      excelHeaders: {
        serie: 'Serie',
        folio: 'Folio',
        codigopostalexpedicion: 'Código postal expedición',
        rfcemisor: 'RFC emisor',
        razonsocialemisor: 'Razón social emisor',
        regimenfiscalemisor: 'Régimen fiscal emisor',
        rfcreceptor: 'RFC receptor',
        razonsocialreceptor: 'Razón social receptor',
        regimenfiscalreceptor: 'Régimen fiscal receptor',
        codigopostalreceptor: 'Código postal receptor',
        usodelcfdi: 'Uso del CFDI',
        cantidad: 'Cantidad',
        codigounidaddemedida: 'Código unidad de medida',
        codigoproductooservicio: 'Código producto o servicio',
        descripcionproductooservicio: 'Descripción producto o servicio',
        identificador: 'Identificador',
        metododepago: 'Método de pago',
        formadepago: 'Forma de pago',
        preciounitario: 'Precio unitario',
        descuento: 'Descuento',
        objetodeimpuesto: 'Objeto de impuesto',
        tipodeimpuesto: 'Tipo de impuesto',
        tasadeimpuesto: 'Tasa de impuesto',
        placavehiculo: 'Placa vehículo',
        nombreconductor: 'Nombre conductor',
        tipoubicacion: 'Tipo ubicación',
        idubicacion: 'ID ubicación',
        nombreubicacion: 'Nombre ubicación',
        rfc: 'RFC',
        codigopostal: 'Código postal',
        calle: 'Calle',
        numeroexterior: 'Número exterior',
        numerointerior: 'Número interior',
        localidad: 'Localidad',
        colonia: 'Colonia',
        municipioalcaldia: 'Municipio/Alcaldía',
        estado: 'Estado',
        fechadesalidallegada: 'Fecha de salida/llegada',
        horadesalidallegada: 'Hora de salida/llegada',
        distanciarecorrida: 'Distancia recorrida',
        descripcionmercancia: 'Descripción mercancía',
        pesoenkg: 'Peso en kg',
        idorigen: 'ID origen',
        iddestino: 'ID destino',
        materialpeligroso: 'Material peligroso',
        codigomaterialpeligroso: 'Código material peligroso',
        embalajematerialpeligroso: 'Embalaje material peligroso',
        permisosct: 'Permiso SCT',
        numeropermisosct: 'Número permiso SCT',
        configuracionvehicular: 'Configuración vehicular',
        pesobrutovehicularton: 'Peso bruto vehicular (ton)',
        placa: 'Placa',
        ano: 'Año',
        nombreaseguradoracivil: 'Nombre aseguradora civil',
        numeropolizaaseguradoracivil: 'Número póliza aseguradora civil',
        tiporemolque: 'Tipo remolque',
        placaremolque: 'Placa remolque',
        tipoconductor: 'Tipo conductor',
        rfcconductor: 'RFC conductor',
        numerolicenciadeconducir: 'Número licencia de conducir',
      },
      bodyExcel: null,
      isCfdiGenerating: false,
      errorMessageList: [],
      showCfdiValidateAlert: false,
      showCfdiSuccessAlert: false,
      loadingNewCfdi: false,
      isDownloadingCfdi: null,
      availableStamps: null,
      routeDetail: null,
      enabledService: false,
      fileTypeAlert: false,
      invalidFileAlert: false,
      cfdiFileTypeIngreso: false,
      cfdiCCP: false,
      activeDropdown: null,
      catalogDriverType: [
        {
          Id: "01",
          Value: "Operador",
        },
        {
          Id: "02",
          Value: "Propietario",
        },
        {
          Id: "03",
          Value: "Arrendador",
        },
        {
          Id: "04",
          Value: "Notificado",
        },
        {
          Id: "05",
          Value: "Integrante de Coordinados",
        },
      ],
      logService: null,
    };
  },
  created() {
    this.logService = Container.get(LogService);
    this.prepareData();
  },
  methods: {
    async prepareData() {
      try {
        this.isMainPageBussy = true;
        this.routeDetail = await this.route;
        // 🔹 Ejecutar todas las llamadas en paralelo
        const [
          issuers,
          receivers,
          cfdiUses,
          taxRegimes,
          units,
          cfdis,
          stamps,
          routeDetail,
          itemDataList,
          taxObjectList,
          paymentMethodList,
          paymentFormList,
        ] = await Promise.all([
          this.getIssuerInfo(),
          this.getReceiverInfo(),
          this.getCfdiUseInfo(),
          this.getTaxRegimenInfo(),
          this.getUnitsInfo(),
          this.getCfdiList(),
          this.getConfigClient(),
          this.getRouteDetail(),
          this.getItemDataList(),
          this.getTaxObjectInfo(),
          this.getPaymentMethodInfo(),
          this.getPaymentFormInfo(),
        ]);

        // 🔹 Asignar los valores una vez que todas las promesas se resuelvan
        this.issuerList = issuers;
        this.receiverList = receivers;
        this.cfdiUseList = cfdiUses;
        this.taxRegimeList = taxRegimes;
        this.unitList = units;
        this.cfdiList = cfdis;
        this.availableStamps = stamps;
        this.routeDetail = routeDetail;
        this.itemDataList = itemDataList;
        this.taxObjectList = taxObjectList;
        this.paymentMethodList = paymentMethodList;
        this.paymentFormList = paymentFormList;
        // 🔹 Llamar al metodo que depende de issuerList y receiverList
        this.preSelectHolders(issuers, receivers);
      } catch (error) {
        console.error('Error al cargar datos:', error);
      } finally {
        this.isMainPageBussy = false;
      }
    },
    preSelectHolders(issuers, receivers) {
      if (issuers.length == 1) {
        this.cfdi.issuer = issuers[0];
      }
      if (receivers.length == 1) {
        this.cfdi.receiver = receivers[0];
      }
    },
    async getIssuerInfo() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/holder?holderType=issuer`, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          const issuers = response.data.data;
          const issuer = issuers[0];
          return [
            {
              Id: issuer.id,
              LegalName: issuer.LegalName,
              TrackingName: issuer.Name ? issuer.Name : issuer.LegalName,
              Rfc: issuer.Rfc,
              Name: issuer.Name,
              RegimenFiscal: issuer.RegimenFiscal,
              CfdiUse: null,
              PostalCode: issuer.PostalCode,
            },
          ];
        }
        return [];
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getReceiverInfo() {
      try {
        const url = `${store.getters.urlCartaPorte}/holder?holderType=receiver`;
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        const receivers = [];
        response.data.data.forEach((holderTemp) => {
          receivers.push({
            Id: holderTemp.id,
            LegalName: holderTemp.LegalName,
            TrackingName: holderTemp.Name ? holderTemp.Name : holderTemp.LegalName,
            Rfc: holderTemp.Rfc,
            Name: holderTemp.Name,
            RegimenFiscal: holderTemp.RegimenFiscal,
            CfdiUse: holderTemp.CfdiUse,
            PostalCode: holderTemp.PostalCode,
          });
        });
        return receivers;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async getCfdiUseInfo() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/catalogs/CfdiUses`, {
          headers: {
            'id-client': store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    async getTaxRegimenInfo() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/catalogs/FiscalRegimens`, {
          headers: {
            'id-client': store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    async getUnitsInfo() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/catalogs/Units`, {
          headers: {
            'id-client': store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    async getTaxObjectInfo() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/catalogs/TaxObject`, {
          headers: {
            'id-client': store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data.filter((obj) => obj.Id !== 5); //!Temporalmente se remueve objeto de impuesto 5 por limitaciones de facturama
          //return response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    async getPaymentMethodInfo() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/catalogs/PaymentMethods`, {
          headers: {
            'id-client': store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    async getPaymentFormInfo() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/catalogs/PaymentForms`, {
          headers: {
            'id-client': store.getters.clientId,
          },
        });
        if (response.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    async getCfdiList() {
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            'x-api-key': store.getters.clientApiKey,
          },
        };
        const url = `${store.getters.urlCartaPorte}/route/cfdi`;
        const response = await axios.get(url, config);
        return response.data.data[this.routeDetail.id] || [];
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    async getConfigClient() {
      try {
        const response = await axios.get(`${store.getters.urlCartaPorte}/config`, {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        });

        const availableStamps = response.data.data.totalStamps - response.data.data.actualStamps;
        this.enabledService = response.data.data.enabledService;
        if (response.data.status) {
          return availableStamps;
        } else {
          return 0;
        }
      } catch (e) {
        console.log(e);
        return 0;
      }
    },
    async getRouteDetail() {
      const urlRoute = `${store.getters.urlAPI}/route/${this.route.id}`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return this.route;
      }
    },
    async getItemDataList() {
      const urlRoute = `${store.getters.urlAPI}/api/itemData`;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlRoute, config);
        return response.data.data;
      } catch (e) {
        console.log(e);
        return this.route;
      }
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que permite interactuar con los .json de las traducciones.
     * @param {String} key, es el elemento del .json a utilizar.
     * @param {String} value, es la variable a insertar (en caso de que el elemento lo solicite).
     * @returns el resultado de la traduccion.
     */
    t(key, value) {
      return i18n.t(key, value);
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    async getCfdiTemplate() {
      if (this.cfdiType === 'T') {
        if (this.cartaPorteEnabled) {
          this.generateCfdiTrasladoCCartaPorte();
        } else {
          this.generateCfdiTraslado();
        }
      } else {
        if (this.cartaPorteEnabled) {
          this.generateCfdiIngresoCCartaPorte();
        } else {
          this.generateCfdiIngreso();
        }
      }
    },
    async generateCfdiTraslado() {
      const workbook = new ExcelJS.Workbook();

      // Crear hojas
      const generalData = workbook.addWorksheet('CFDI - Datos generales');
      const concept = workbook.addWorksheet('CFDI - Conceptos');
      const observations = workbook.addWorksheet('CFDI - Conductor y vehículo');

      generalData.columns = [
        { header: this.excelHeaders.serie, key: 'serie', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.folio, key: 'folio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalexpedicion, key: 'codigopostalexpedicion', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcemisor, key: 'rfcemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialemisor, key: 'razonsocialemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalemisor, key: 'regimenfiscalemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcreceptor, key: 'rfcreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialreceptor, key: 'razonsocialreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalreceptor, key: 'regimenfiscalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalreceptor, key: 'codigopostalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.usodelcfdi, key: 'usodelcfdi', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      generalData.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.serie') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.folio') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalexpedicion') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalemisor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('I1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalreceptor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('J1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('K1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('K1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.usodelcfdi') + '\n' + '\n' },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };

      concept.columns = [
        { header: this.excelHeaders.cantidad, key: 'cantidad', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigounidaddemedida, key: 'codigounidaddemedida', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigoproductooservicio, key: 'codigoproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.descripcionproductooservicio, key: 'descripcionproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.identificador, key: 'identificador', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      concept.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.cantidad') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('B1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigounidaddemedida') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogUnit') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigoproductooservicio') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogProduct') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.descripcionproductooservicio'),
          },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.identificador') },
        ],
        editAs: 'twoCells',
      };

      observations.columns = [
        { header: this.excelHeaders.placavehiculo, key: 'placavehiculo', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.nombreconductor, key: 'nombreconductor', width: 30, style: { numFmt: '@' } },
      ];
      observations.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.vehicle') },
        ],
        editAs: 'twoCells',
      };
      observations.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.driver') },
        ],
        editAs: 'twoCells',
      };

      generalData.addRow({
        serie: '',
        folio: '',
        codigopostalexpedicion: this.cfdi.issuer != null ? this.cfdi.issuer.PostalCode : '',
        rfcemisor: this.cfdi.issuer != null ? this.cfdi.issuer.Rfc : '',
        razonsocialemisor: this.cfdi.issuer != null ? this.cfdi.issuer.LegalName : '',
        regimenfiscalemisor:
          this.cfdi.issuer != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Name
            : '',
        rfcreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.Rfc : '',
        razonsocialreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.LegalName : '',
        regimenfiscalreceptor:
          this.cfdi.receiver != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Name
            : '',
        codigopostalreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.PostalCode : '',
        usodelcfdi:
          this.cfdi.receiver != null
            ? this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Value +
              ' - ' +
              this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Name
            : '',
      });

      for (const trip of this.routeDetail.trips) {
        for (const activity of trip.activities) {
          for (const document of activity.documents) {
            for (const item of document.items) {
              const itemDataTemp = this.itemDataList.find((itemData) => itemData.id === item.idItemData);
              concept.addRow({
                cantidad: item.quantity,
                codigounidaddemedida: '',
                codigoproductooservicio: '',
                descripcionproductooservicio: item.name,
                identificador: itemDataTemp ? itemDataTemp.code : '',
              });
            }
          }
        }
      }
      for (const assignation of this.routeDetail.assignations) {
        observations.addRow({
          placavehiculo: assignation.vehicle ? assignation.vehicle.plate : '',
          nombreconductor: assignation.driver ? `${assignation.driver.firstName} ${assignation.driver.lastName}` : '',
        });
      }
      for (let i = 0; i < this.taxRegimeList.length; i++) {
        generalData.getCell(`$XA$${i + 1}`).value = this.taxRegimeList[i].Value + ' - ' + this.taxRegimeList[i].Name;
      }

      for (let i = 0; i < this.cfdiUseList.length; i++) {
        generalData.getCell(`$XB$${i + 1}`).value = this.cfdiUseList[i].Value + ' - ' + this.cfdiUseList[i].Name;
      }

      generalData.getColumn(625).hidden = true; //XA
      generalData.getColumn(626).hidden = true; //XB

      for (let i = 2; i < 200; i++) {
        generalData.getCell(`I${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`F${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`K${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XB$1:$XB$${this.cfdiUseList.length}`],
        };
      }

      // Guardar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), 'cfdi_traslado.xlsx');
    },
    async validateFileType() {
      if (this.file != null && this.matchedValue == 0) {
        this.invalidFileAlert = true;
        this.fileTypeAlert = false;
      } else {
        if (this.bodyExcel && this.bodyExcel.CfdiType != this.cfdiType) {
          this.fileTypeAlert = true;
        } else {
          if (this.cfdiCCP) {
            if (!this.cartaPorteEnabled) {
              this.fileTypeAlert = true;
            } else {
              this.fileTypeAlert = false;
            }
          } else {
            this.fileTypeAlert = false;
          }          
        }
      }
    },
    isEmpty(value) {
      return value === undefined || value === null || value === "";
    },    
    validateGeneralData() {
      if (this.isEmpty(this.generalDataExcel[0].codigopostalexpedicion)) {
        this.validationMessages.push("Codigo postal expedicion es requerido");
      }
      if (this.isEmpty(this.generalDataExcel[0].razonsocialreceptor)) {
        this.validationMessages.push("Razón social receptor es requerido");
      }
      if (this.isEmpty(this.generalDataExcel[0].usodelcfdi)) {
        this.validationMessages.push("Uso del CFDI es requerido");
      }
      if (this.isEmpty(this.generalDataExcel[0].rfcreceptor)) {
        this.validationMessages.push("RFC del receptor es requerido");
      }
      if (this.isEmpty(this.generalDataExcel[0].regimenfiscalreceptor)) {
        this.validationMessages.push("Régimen fiscal del receptor es requerido");
      }
      if (this.isEmpty(this.generalDataExcel[0].regimenfiscalemisor)) {
        this.validationMessages.push("Régimen fiscal del emisor es requerido");
      }
      if (this.isEmpty(this.generalDataExcel[0].rfcemisor)) {
        this.validationMessages.push("RFC del emisor es requerido");
      }
      if (this.isEmpty(this.generalDataExcel[0].razonsocialemisor)) {
        this.validationMessages.push("Razón social emisor es requerido");
      }
      if (this.cfdiFileTypeIngreso) {
        if (this.isEmpty(this.generalDataExcel[0].formadepago)) {
          this.validationMessages.push("Forma de pago es requerido en CFDI de tipo ingreso");
        }
        if (this.isEmpty(this.generalDataExcel[0].metododepago)) {
          this.validationMessages.push("Método de pago es requerido en CFDI de tipo ingreso");
        }
      }
    },
    validateConceptData(conceptData, index) {
      if (this.bodyExcel.CfdiType == 'I') {
        if (this.isEmpty(conceptData.objetodeimpuesto)) {
          this.validationMessages.push(`Objeto impuesto en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.codigounidaddemedida)) {
          this.validationMessages.push(`Código unidad de medida en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.cantidad)) {
          this.validationMessages.push(`Cantidad en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.codigoproductooservicio)) {
          this.validationMessages.push(`Código producto o servicio en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.descripcionproductooservicio)) {
          this.validationMessages.push(`Descripción producto o servicio en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.identificador)) {
          this.validationMessages.push(`Identificador en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.preciounitario)) {
          this.validationMessages.push(`Precio unitario en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.descuento)) {
          this.validationMessages.push(`Descuento en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.tipodeimpuesto)) {
          this.validationMessages.push(`Tipo de impuesto en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
        if (this.isEmpty(conceptData.tasadeimpuesto)) {
          this.validationMessages.push(`Tasa de impuesto en ítem ${index} en CFDI de tipo ingreso es requerido`);
        }
      } else {
        if (this.isEmpty(conceptData.cantidad)) {
          this.validationMessages.push(`Cantidad en ítem ${index} en CFDI de tipo traslado es requerido`);
        }
        if (this.isEmpty(conceptData.codigounidaddemedida)) {
          this.validationMessages.push(`Código unidad de medida en ítem ${index} en CFDI de tipo traslado es requerido`);
        }
        if (this.isEmpty(conceptData.codigoproductooservicio)) {
          this.validationMessages.push(`Código producto o servicio en ítem ${index} en CFDI de tipo traslado es requerido`);
        }
        if (this.isEmpty(conceptData.descripcionproductooservicio)) {
          this.validationMessages.push(`Descripción producto o servicio en ítem ${index} en CFDI de tipo traslado es requerido`);
        }
        if (this.isEmpty(conceptData.identificador)) {
          this.validationMessages.push(`Identificador en ítem ${index} en CFDI de tipo traslado es requerido`);
        }
      }
    },
    validateLocationData(locationData, index) {
      if (this.isEmpty(locationData.tipoubicacion)) {
        this.validationMessages.push(`Tipo ubicación en ubicación ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(locationData.idubicacion)) {
        this.validationMessages.push(`ID ubicación en ubicación ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(locationData.rfc)) {
        this.validationMessages.push(`RFC en ubicación ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(locationData.codigopostal)) {
        this.validationMessages.push(`Código postal en ubicación ${index} en CFDI con CCP es requerido`);
      }
     /*  if (this.isEmpty(locationData.localidad)) {
        this.validationMessages.push(`Localidad en ubicación ${index} en CFDI con CCP es requerido`);
      } */
      if (this.isEmpty(locationData.municipioalcaldia)) {
        this.validationMessages.push(`Municipio/Alcaldía en ubicación ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(locationData.estado)) {
        this.validationMessages.push(`Estado en ubicación ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(locationData.fechadesalidallegada)) {
        this.validationMessages.push(`Fecha de salida/llegada en ubicación ${index} en CFDI con CCP es requerido`);
      } else {
        // Validar que el mes esté entre 01 y 12
        const fecha = String(locationData.fechadesalidallegada);
        const partes = fecha.split("-");
        const mes = parseInt(partes[1], 10);
        if (mes < 1 || mes > 12) {
          this.validationMessages.push(`Mes inválido en fecha de ubicación ${index}. Debe estar entre 01 y 12`);
        }
      }
      if (this.isEmpty(locationData.horadesalidallegada)) {
        this.validationMessages.push(`Hora de salida/llegada en ubicación ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(locationData.distanciarecorrida)) {
        this.validationMessages.push(`Distancia recorrida en ubicación ${index} en CFDI con CCP es requerido`);
      }
    },
    validateMerchData(merchData, index) {
      if (this.isEmpty(merchData.codigoproductooservicio)) {
        this.validationMessages.push(`Código producto o servicio en mercancía ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(merchData.descripcionmercancia)) {
        this.validationMessages.push(`Descripción en mercancía ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(merchData.cantidad)) {
        this.validationMessages.push(`Cantidad en mercancía ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(merchData.codigounidaddemedida)) {
        this.validationMessages.push(`Código unidad de medida en mercancía ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(merchData.pesoenkg)) {
        this.validationMessages.push(`Peso en kg en mercancía ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(merchData.idorigen)) {
        this.validationMessages.push(`ID origen en mercancía ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(merchData.iddestino)) {
        this.validationMessages.push(`ID destino en mercancía ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(merchData.materialpeligroso)) {
        this.validationMessages.push(`Declarar si mercancía ${index} es material peligroso en CFDI con CCP es requerido`);
      } else {
        if (merchData.materialpeligroso.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() === "si") {
          if (this.isEmpty(merchData.codigomaterialpeligroso)) {
            this.validationMessages.push(`Código material peligroso en mercancía ${index} en CFDI con CCP es requerido`);
          }
          if (this.isEmpty(merchData.embalajematerialpeligroso)) {
            this.validationMessages.push(`Embalaje material peligroso en mercancía ${index} en CFDI con CCP es requerido`);
          }
        }
      }
    },
    validateVehicleData(vehicleData, index) {
      if (this.isEmpty(vehicleData.permisosct)) {
        this.validationMessages.push(`Permiso SCT en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.numeropermisosct)) {
        this.validationMessages.push(`Número permiso SCT en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.configuracionvehicular)) {
        this.validationMessages.push(`Configuración vehicular en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.pesobrutovehicularton)) {
        this.validationMessages.push(`Peso bruto vehicular (ton) en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.placa)) {
        this.validationMessages.push(`Placa en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.ano)) {
        this.validationMessages.push(`Año en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.nombreaseguradoracivil)) {
        this.validationMessages.push(`Nombre aseguradora civil en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.numeropolizaaseguradoracivil)) {
        this.validationMessages.push(`Número póliza aseguradora civil en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }

      if (this.isEmpty(vehicleData.tipoconductor)) {
        this.validationMessages.push(`Tipo conductor en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.rfcconductor)) {
        this.validationMessages.push(`RFC conductor en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.numerolicenciadeconducir)) {
        this.validationMessages.push(`Número licencia de conducir en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
      if (this.isEmpty(vehicleData.nombreconductor)) {
        this.validationMessages.push(`Nombre conductor en vehiculo y conductor ${index} en CFDI con CCP es requerido`);
      }
    },
    async readFileExcel() {
      try {
        this.cfdiFileTypeIngreso = false;
        this.invalidFileAlert = false;
        this.fileTypeAlert = false;
        this.cfdiCCP = false;
        this.matchedValue = 0;
        this.generalDataExcel = await this.prepareFileExcel(this.generalDataExcel);
        this.conceptDataExcel = await this.prepareFileExcel(this.conceptDataExcel);
        this.validationMessages = [];
        
        this.locationsDataExcel = await this.prepareFileExcel(this.locationsDataExcel);
        this.merchDataExcel = await this.prepareFileExcel(this.merchDataExcel);
        this.vehicleDriverDataExcel = await this.prepareFileExcel(this.vehicleDriverDataExcel); 
  
        if (!this.cartaPorteEnabled && !this.cfdiCCP) {
          this.observations = await this.prepareFileExcel(this.observations);
        }
  
        if (this.file != null && this.matchedValue == 0) {
          this.invalidFileAlert = true;
          return;
        }
        if (this.generalDataExcel.length > 0) {
          this.validateGeneralData();
          this.bodyExcel = {
            CfdiType: this.cfdiFileTypeIngreso ? 'I' : 'T',
            Serie:
              this.generalDataExcel[0].serie !== null && this.generalDataExcel[0].serie !== undefined
                ? String(this.generalDataExcel[0].serie)
                : '',
            Folio:
              this.generalDataExcel[0].folio !== null && this.generalDataExcel[0].folio !== undefined
                ? String(this.generalDataExcel[0].folio)
                : '',
            ExpeditionPlace: this.generalDataExcel[0].codigopostalexpedicion ? String(this.generalDataExcel[0].codigopostalexpedicion) : "",
            Receiver: {
              Name: this.generalDataExcel[0].razonsocialreceptor,
              CfdiUse: this.cfdiFileTypeIngreso ? 
                            this.cfdiUseList.find((item) => item.Value + ' - ' + item.Name == this.generalDataExcel[0].usodelcfdi).Value 
                            : "S01",
              Rfc: this.generalDataExcel[0].rfcreceptor,
              FiscalRegime: this.generalDataExcel[0].regimenfiscalreceptor ? String(
                this.taxRegimeList.find(
                  (item) => item.Value + ' - ' + item.Name == this.generalDataExcel[0].regimenfiscalreceptor,
                ).Value,
              ) : "",
              TaxZipCode: this.generalDataExcel[0].codigopostalreceptor ? String(this.generalDataExcel[0].codigopostalreceptor) : "",
            },
            Issuer: {
              FiscalRegime: this.generalDataExcel[0].regimenfiscalemisor ? String(
                this.taxRegimeList.find(
                  (item) => item.Value + ' - ' + item.Name == this.generalDataExcel[0].regimenfiscalemisor,
                ).Value,
              ) : "",
              Rfc: this.generalDataExcel[0].rfcemisor,
              Name: this.generalDataExcel[0].razonsocialemisor,
            },
          };
          if (!this.cartaPorteEnabled && !this.cfdiCCP && this.observations) {
            this.bodyExcel.Observations = this.buildObservations(this.observations);
          }
          if (this.cfdiFileTypeIngreso) {
            this.bodyExcel.PaymentForm =
              this.generalDataExcel[0].formadepago != null && this.generalDataExcel[0].formadepago != ''
                ? String(
                    this.paymentFormList.find(
                      (item) => item.Value + ' - ' + item.Name == this.generalDataExcel[0].formadepago,
                    ).Value,
                  )
                : '';
            this.bodyExcel.PaymentMethod =
              this.generalDataExcel[0].metododepago != null && this.generalDataExcel[0].metododepago != ''
                ? String(
                    this.paymentMethodList.find(
                      (item) => item.Value + ' - ' + item.Name == this.generalDataExcel[0].metododepago,
                    ).Value,
                  )
                : '';
          }
        }
        let items = [];
        let index = 1;
        for (let row of this.conceptDataExcel) {
          if (
            row.codigounidaddemedida !== undefined ||
            row.cantidad !== undefined ||
            row.codigoproductooservicio !== undefined ||
            row.descripcionproductooservicio !== undefined ||
            row.identificador !== undefined ||
            row.preciounitario !== undefined ||
            row.descuento !== undefined ||
            row.objetodeimpuesto !== undefined ||
            row.tipodeimpuesto !== undefined ||
            row.tasadeimpuesto !== undefined
          ) {
            this.validateConceptData(row, index);
            index++;
            if (this.bodyExcel.CfdiType == 'I' && row.objetodeimpuesto !== undefined) {
              const resultUnit = this.unitList.find((unitTemp) => unitTemp.Value === String(row.codigounidaddemedida));
              const resultTaxObject = this.taxObjectList.find(
                (item) => item.Value + ' - ' + item.Name === row.objetodeimpuesto,
              );
              items.push({
                Quantity: row.cantidad ? Number(row.cantidad) : 0,
                Unit: resultUnit ? resultUnit.ShortName : '', //se obtiene de catalogo segun UnitCode ingresado
                UnitCode:
                  row.codigounidaddemedida === null ||
                  row.codigounidaddemedida === undefined ||
                  row.codigounidaddemedida === ''
                    ? ''
                    : String(row.codigounidaddemedida),
                ProductCode:
                  row.codigoproductooservicio === null ||
                  row.codigoproductooservicio === undefined ||
                  row.codigoproductooservicio === ''
                    ? ''
                    : String(row.codigoproductooservicio),
                Description: row.descripcionproductooservicio,
                UnitPrice: this.bodyExcel.CfdiType == 'I' ? Number(row.preciounitario) : 0,
                Discount:
                  this.bodyExcel.CfdiType == 'I' &&
                  (row.descuento === null || row.descuento === undefined || row.descuento === '')
                    ? 0
                    : Number(row.descuento),
                IdentificationNumber: row.identificador ? String(row.identificador) : "",
                TaxObject: this.bodyExcel.CfdiType == 'I' ? String(resultTaxObject.Value) : '01',
                Taxes:
                  this.bodyExcel.CfdiType == 'I' && String(resultTaxObject.Value) == '02'
                    ? [
                        {
                          Name: row.tipodeimpuesto,
                          Rate: row.tasadeimpuesto ? parseFloat(row.tasadeimpuesto) : 0.0,
                          IsRetention: row.tipodeimpuesto === 'IVA RET' || row.tipodeimpuesto === 'ISR' ? true : false,
                        },
                      ]
                    : undefined,
              });            
            } else if (this.bodyExcel.CfdiType == 'T') {
              const resultTaxObject = this.taxObjectList.find(
                (item) => item.Value + ' - ' + item.Name === row.objetodeimpuesto,
              );
              const resultUnit = row.codigounidaddemedida ? this.unitList.find((unitTemp) => unitTemp.Value === String(row.codigounidaddemedida)) : undefined;
              items.push({
                Quantity: row.cantidad ? Number(row.cantidad) : 0,
                Unit: resultUnit ? resultUnit.ShortName : '', //se obtiene de catalogo segun UnitCode ingresado
                UnitCode:
                  row.codigounidaddemedida === null ||
                  row.codigounidaddemedida === undefined ||
                  row.codigounidaddemedida === ''
                    ? ''
                    : String(row.codigounidaddemedida),
                ProductCode:
                  row.codigoproductooservicio === null ||
                  row.codigoproductooservicio === undefined ||
                  row.codigoproductooservicio === ''
                    ? ''
                    : String(row.codigoproductooservicio),
                Description: row.descripcionproductooservicio,
                UnitPrice: this.bodyExcel.CfdiType == 'I' ? Number(row.preciounitario) : 0,
                Discount:
                  this.bodyExcel.CfdiType == 'I' &&
                  (row.descuento === null || row.descuento === undefined || row.descuento === '')
                    ? 0
                    : Number(row.descuento),
                IdentificationNumber: row.identificador ? String(row.identificador) : "",
                TaxObject: this.bodyExcel.CfdiType == 'I' ? String(resultTaxObject.Value) : '01',
                Taxes:
                  this.bodyExcel.CfdiType == 'I' && String(resultTaxObject.Value) == '02'
                    ? [
                        {
                          Name: row.tipodeimpuesto,
                          Rate: row.tasadeimpuesto ? parseFloat(row.tasadeimpuesto) : 0.0,
                          IsRetention: row.tipodeimpuesto === 'IVA RET' || row.tipodeimpuesto === 'ISR' ? true : false,
                        },
                      ]
                    : undefined,
              });
            }
          }
        }
  
        const ubicaciones = [];
        const mercancias= [];
        const vehicles = [];
        const drivers = [];
        let totalDistRec = 0;
  
        this.bodyExcel.Items = items;
        console.log(`Es tipo de CPP ${this.cfdiCCP}`);
        if (this.cfdiCCP) {
          index = 1;
          for (let row of this.locationsDataExcel) {
            if (
              row.tipoubicacion !== undefined ||
              row.idubicacion !== undefined ||
              row.nombreubicacion !== undefined ||
              row.rfc !== undefined ||
              row.codigopostal !== undefined ||
              row.calle !== undefined ||
              row.numeroexterior !== undefined ||
              row.numerointerior !== undefined ||
              row.localidad !== undefined ||
              row.colonia !== undefined ||
              row.municipioalcaldia !== undefined ||
              row.estado !== undefined ||
              row.fechadesalidallegada !== undefined ||
              row.horadesalidallegada !== undefined||
              row.distanciarecorrida !== undefined
            ) {
              this.validateLocationData(row, index);
              index++;
              let formattedId = null;
              if (row.tipoubicacion === 'Origen' && row.idubicacion) {
                formattedId = `OR${row.idubicacion.toString().padStart(6, '0')}`;
              } else if (row.tipoubicacion === 'Destino' && row.idubicacion) {
                formattedId = `DE${row.idubicacion.toString().padStart(6, '0')}`;
              }
              let distance = "0";
              if (row.distanciarecorrida) { 
                const discanteStringTemp = String(row.distanciarecorrida);
                if (!isNaN(discanteStringTemp) && discanteStringTemp.trim() !== "") {
                  const numero = parseFloat(discanteStringTemp);
                  const redondeado = parseFloat(numero.toFixed(2));
                  distance = String(redondeado);
                  totalDistRec += redondeado;
                }
              }

              const ubicacion = {
                NombreRemitenteDestinatario: row.nombreubicacion ? String(row.nombreubicacion) : '',
                TipoUbicacion: row.tipoubicacion ? String(row.tipoubicacion) : '',
                IDUbicacion: formattedId ? formattedId : '',
                FechaHoraSalidaLlegada: row.fechadesalidallegada 
                  ? `${String(row.fechadesalidallegada)} ${String(
                      row.horadesalidallegada.split(':').slice(0, 2).join(':'),
                    )}:00` : '',
                RFCRemitenteDestinatario: row.rfc ? String(row.rfc) : '',
                DistanciaRecorrida: distance,
                Domicilio: {
                  Pais: "MEX",
                  CodigoPostal: row.codigopostal ? String(row.codigopostal) : "",
                  Estado: row.estado ? String(row.estado) : "",
                  Municipio: row.municipioalcaldia ? String(row.municipioalcaldia) : "",
                  Localidad: row.localidad ? String(row.localidad) : "",
                  Calle: row.calle ? String(row.calle) : "",
                  NumeroExterior: row.numeroexterior ? String(row.numeroexterior) : "",
                  NumeroInterior: row.numerointerior ? String(row.numerointerior) : "",
                  Colonia: row.colonia ? String(row.colonia) : "",              
                },
              };
              console.log('ubicacion',ubicacion);
              ubicaciones.push(ubicacion);
            }
          }
    
          let isDangerousMaterial = false;
          let pesoTotal = 0;
          index = 1;
          for (let row of this.merchDataExcel) {
            if (
              row.codigoproductooservicio !== undefined ||
              row.descripcionmercancia !== undefined ||
              row.cantidad !== undefined ||
              row.codigounidaddemedida !== undefined ||
              row.pesoenkg !== undefined ||
              row.idorigen !== undefined ||
              row.iddestino !== undefined ||
              row.materialpeligroso !== undefined ||
              row.codigomaterialpeligroso !== undefined ||
              row.embalajematerialpeligroso !== undefined
            ) {
              this.validateMerchData(row, index);
              index++;
              const resultUnit = this.unitList.find((unitTemp) => unitTemp.Value === String(row.codigounidaddemedida));
  
              const resultado = this.truncarDecimal(row.pesoenkg, 3); // → 3.141
              pesoTotal += resultado;
              let mercancia = {
                BienesTransp: row.codigoproductooservicio ? String(row.codigoproductooservicio) : "",
                Descripcion: row.descripcionmercancia ? String(row.descripcionmercancia) : "",
                Cantidad: row.cantidad ? String(row.cantidad) : "",
                ClaveUnidad: row.codigounidaddemedida === null || row.codigounidaddemedida === undefined || row.codigounidaddemedida === '' ? '' : String(row.codigounidaddemedida),
                Unidad: resultUnit ? String(resultUnit.ShortName) : '', //se obtiene de catalogo segun UnitCode ingresado
                PesoEnKg: resultado ? String(resultado) : "",
                CantidadTransporta: [
                  {
                    Cantidad: row.cantidad ? String(row.cantidad) : "",
                    IDOrigen: row.idorigen ? `OR${row.idorigen.toString().padStart(6, '0')}` : "",
                    IDDestino: row.iddestino ? `DE${row.iddestino.toString().padStart(6, '0')}` : "",
                  }
                ]
              };
  
              if (row.materialpeligroso && row.materialpeligroso.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() === "si") {
                isDangerousMaterial = true;
                mercancia.MaterialPeligroso = "Sí";
                mercancia.CveMaterialPeligroso = row.codigomaterialpeligroso ? String(row.codigomaterialpeligroso) : "";
                mercancia.Embalaje = row.embalajematerialpeligroso ? String(row.embalajematerialpeligroso) : "";
              }
              console.log('mercancia',mercancia);
              mercancias.push(mercancia);
            }
          }
  
          index = 1;
          for (let row of this.vehicleDriverDataExcel) {
            if (
              row.permisosct !== undefined ||
              row.numeropermisosct !== undefined ||
              row.configuracionvehicular !== undefined ||
              row.pesobrutovehicularton !== undefined ||
              row.placa !== undefined ||
              row.ano !== undefined ||
              row.nombreaseguradoracivil !== undefined ||
              row.numeropolizaaseguradoracivil !== undefined ||
              row.tiporemolque !== undefined  ||
              row.placaremolque !== undefined  ||
              row.tipoconductor !== undefined  ||
              row.rfcconductor !== undefined  ||
              row.numerolicenciadeconducir !== undefined  ||
              row.nombreconductor !== undefined 
            ) {
              this.validateVehicleData(row, index);
              index++;
              const vehicle = {
                PermSCT: row.permisosct ? String(row.permisosct) : "",
                NumPermisoSCT: row.numeropermisosct ? String(row.numeropermisosct) : "",
                IdentificacionVehicular: {
                  ConfigVehicular: row.configuracionvehicular ? String(row.configuracionvehicular) : "",
                  PesoBrutoVehicular: row.pesobrutovehicularton ? String(row.pesobrutovehicularton) : "",
                  PlacaVM: row.placa ? String(row.placa) : "",
                  AnioModeloVM: row.ano ? String(row.ano) : "",
                },
                Seguros: {
                  AseguraRespCivil: row.nombreaseguradoracivil ? String(row.nombreaseguradoracivil) : "",
                  PolizaRespCivil: row.numeropolizaaseguradoracivil ? String(row.numeropolizaaseguradoracivil) : "",
                },
                Remolques: row.tiporemolque && row.placaremolque ? [
                  {
                    SubTipoRem: row.tiporemolque ? String(row.tiporemolque) : "",
                    Placa: row.placaremolque ? String(row.placaremolque) : "",
                  }, 
                ] : [],
              };
              if (isDangerousMaterial) {
                vehicle.Seguros.AseguraMedAmbiente = row.nombreaseguradoracivil ? String(row.nombreaseguradoracivil) : "";
                vehicle.Seguros.PolizaMedAmbiente = row.numeropolizaaseguradoracivil ? String(row.numeropolizaaseguradoracivil) : "";
              }
              console.log('vehicle',vehicle);
              vehicles.push(vehicle);
              
              const result = this.catalogDriverType.find((temp) => temp.Value === row.tipoconductor);
              const driver = {
                TipoFigura: result ? String(result.Id) : "",
                RFCFigura: row.rfcconductor ? String(row.rfcconductor) : "",
                NumLicencia: row.numerolicenciadeconducir ? String(row.numerolicenciadeconducir) : "",
                NombreFigura: row.nombreconductor ? String(row.nombreconductor) : "",
              };
              console.log('driver',driver);
              drivers.push(driver);
            }
          }
          this.bodyExcel.Complemento = {};
          this.bodyExcel.Complemento.CartaPorte31 = {
            TotalDistRec: String(totalDistRec.toFixed(2)),
            TranspInternac: "No",
            Ubicaciones: ubicaciones,
            Mercancias: {
              UnidadPeso: "KGM",
              LogisticaInversaRecoleccionDevolucion: "Sí",
              Mercancia: mercancias,
              Autotransporte: vehicles.length > 0 ? vehicles[0] : null,
              PesoBrutoTotal: String(pesoTotal),
            },
            FiguraTransporte: drivers.length > 0 ? drivers : null,
          };
        }
      } catch(e) {
        console.log(e);
        this.validationMessages.push(`Ha ocurrido un error.`);
        this.logService.sendInfo({
          component: 'cfdiModal',
          message: `Ha ocurrido un error al leer una plantilla CFDI de id client ${store.getters.clientId}`,
          data: e,
        });
      }

      console.log('EXCEL PREPROCESADO', this.bodyExcel);
      await this.validateFileType();
    },
    truncarDecimal(num, decimales) {
      const factor = Math.pow(10, decimales);
      return Math.trunc(num * factor) / factor;
    },
    async prepareFileExcel(dataExcel) {
      // Para comparar se quitan los espacios y todo en minuscula de
      // los headers con que se construyeron las plantillas
      const headCompare = {};
      Object.entries(this.excelHeaders).forEach((entry) => {
        const [key, value] = entry;
        headCompare[key] = value
          .replaceAll(' ', '')
          .normalize('NFD')
          .replace(new RegExp('[\\/()]', 'g'), '')
          .replace(/[\u0300-\u036f]/g, '') // ← elimina acentos
          .toLowerCase();
      });
      for (let row of dataExcel) {
        Object.entries(row).forEach((entry) => {
          let [key, value] = entry;
          // Header de la columna entrante pasa a minúsculas sin espacios
          const keySource = key
            .trim()
            .replaceAll(' ', '')
            .normalize('NFD')
            .replace(new RegExp('[\\/()]', 'g'), '')
            .replace(/[\u0300-\u036f]/g, '') // ← elimina acentos
            .toLowerCase();

          if (keySource === 'serie') {
            row.serie = value;
            this.matchedValue++;
          } else if (keySource === 'folio') {
            row.folio = value;
            this.matchedValue++;
          } else if (keySource === 'codigopostalexpedicion') {
            row.codigopostalexpedicion = value;
            this.matchedValue++;
          } else if (keySource === 'rfcemisor') {
            row.rfcemisor = value;
            this.matchedValue++;
          } else if (keySource === 'razonsocialemisor') {
            row.razonsocialemisor = value;
            this.matchedValue++;
          } else if (keySource === 'regimenfiscalemisor') {
            row.regimenfiscalemisor = value;
            this.matchedValue++;
          } else if (keySource === 'rfcreceptor') {
            row.rfcreceptor = value;
            this.matchedValue++;
          } else if (keySource === 'razonsocialreceptor') {
            row.razonsocialreceptor = value;
            this.matchedValue++;
          } else if (keySource === 'regimenfiscalreceptor') {
            row.regimenfiscalreceptor = value;
            this.matchedValue++;
          } else if (keySource === 'codigopostalreceptor') {
            row.codigopostalreceptor = value;
            this.matchedValue++;
          } else if (keySource === 'usodelcfdi') {
            row.usodelcfdi = value;
            this.matchedValue++;
          } else if (keySource === 'cantidad') {
            row.cantidad = value;
            this.matchedValue++;
          } else if (keySource === 'codigounidaddemedida') {
            row.codigounidaddemedida = value;
            this.matchedValue++;
          } else if (keySource === 'codigoproductooservicio') {
            row.codigoproductooservicio = value;
            this.matchedValue++;
          } else if (keySource === 'descripcionproductooservicio') {
            row.descripcionproductooservicio = value;
            this.matchedValue++;
          } else if (keySource === 'identificador') {
            row.identificador = value;
            this.matchedValue++;
          } else if (keySource === 'metododepago') {
            this.cfdiFileTypeIngreso = true;
            row.metododepago = value;
            this.matchedValue++;
          } else if (keySource === 'formadepago') {
            this.cfdiFileTypeIngreso = true;
            row.formadepago = value;
            this.matchedValue++;
          } else if (keySource === 'preciounitario') {
            row.preciounitario = value;
            this.matchedValue++;
          } else if (keySource === 'descuento') {
            row.descuento = value;
            this.matchedValue++;
          } else if (keySource === 'objetodeimpuesto') {
            row.objetodeimpuesto = value;
            this.matchedValue++;
          } else if (keySource === 'tipodeimpuesto') {
            row.tipodeimpuesto = value;
            this.matchedValue++;
          } else if (keySource === 'tasadeimpuesto') {
            row.tasadeimpuesto = value;
            this.matchedValue++;
          } else if (keySource === 'placavehiculo') {
            row.placavehiculo = value;
            this.matchedValue++;
          } else if (keySource === 'nombreconductor') {
            row.nombreconductor = value;
            this.matchedValue++;
          } else if (keySource === 'tipoubicacion') {
            this.cfdiCCP = true;
            row.tipoubicacion = value;
            this.matchedValue++;
          } else if (keySource === 'idubicacion') {
            this.cfdiCCP = true;
            row.idubicacion = value;
            this.matchedValue++;
          } else if (keySource === 'nombreubicacion') {
            this.cfdiCCP = true;
            row.nombreubicacion = value;
            this.matchedValue++;
          } else if (keySource === 'rfc') {
            row.rfc = value;
            this.matchedValue++;
          } else if (keySource === 'codigopostal') {
            row.codigopostal = value;
            this.matchedValue++;
          } else if (keySource === 'calle') {
            row.calle = value;
            this.matchedValue++;
          } else if (keySource === 'numeroexterior') {
            row.numeroexterior = value;
            this.matchedValue++;
          } else if (keySource === 'numerointerior') {
            row.numerointerior = value;
            this.matchedValue++;
          } else if (keySource === 'localidad') {
            row.localidad = value;
            this.matchedValue++;
          } else if (keySource === 'colonia') {
            row.colonia = value;
            this.matchedValue++;
          } else if (keySource === 'municipioalcaldia') {
            row.municipioalcaldia = value;
            this.matchedValue++;
          } else if (keySource === 'estado') {
            row.estado = value;
            this.matchedValue++;
          } else if (keySource === 'fechadesalidallegada') {
            this.cfdiCCP = true;
            row.fechadesalidallegada = value;
            this.matchedValue++;
          } else if (keySource === 'horadesalidallegada') {
            this.cfdiCCP = true;
            row.horadesalidallegada = value;
            this.matchedValue++;
          } else if (keySource === 'distanciarecorrida') {
            this.cfdiCCP = true;
            row.distanciarecorrida = value;
            this.matchedValue++;
          } else if (keySource === 'codigoproductooservicio') {
            row.codigoproductooservicio = value;
            this.matchedValue++;
          } else if (keySource === 'descripcionmercancia') {
            row.descripcionmercancia = value;
            this.matchedValue++;
          } else if (keySource === 'pesoenkg') {
            row.pesoenkg = value;
            this.matchedValue++;
          } else if (keySource === 'idorigen') {
            row.idorigen = value;
            this.matchedValue++;
          } else if (keySource === 'iddestino') {
            row.iddestino = value;
            this.matchedValue++;
          } else if (keySource === 'materialpeligroso') {
            row.materialpeligroso = value;
            this.matchedValue++;
          } else if (keySource === 'codigomaterialpeligroso') {
            row.codigomaterialpeligroso = value;
            this.matchedValue++;
          } else if (keySource === 'embalajematerialpeligroso') {
            row.embalajematerialpeligroso = value;
            this.matchedValue++;
          } else if (keySource === 'permisosct') {
            this.cfdiCCP = true;
            row.permisosct = value;
            this.matchedValue++;
          } else if (keySource === 'numeropermisosct') {
            this.cfdiCCP = true;
            row.numeropermisosct = value;
            this.matchedValue++;
          } else if (keySource === 'configuracionvehicular') {
            this.cfdiCCP = true;
            row.configuracionvehicular = value;
            this.matchedValue++;
          } else if (keySource === 'pesobrutovehicularton') {
            this.cfdiCCP = true;
            row.pesobrutovehicularton = value;
            this.matchedValue++;
          } else if (keySource === 'placa') {
            this.cfdiCCP = true;
            row.placa = value;
            this.matchedValue++;
          } else if (keySource === 'ano') {
            this.cfdiCCP = true;
            row.ano = value;
            this.matchedValue++;
          } else if (keySource === 'nombreaseguradoracivil') {
            row.nombreaseguradoracivil = value;
            this.matchedValue++;
          } else if (keySource === 'numeropolizaaseguradoracivil') {
            row.numeropolizaaseguradoracivil = value;
            this.matchedValue++;
          } else if (keySource === 'tiporemolque') {
            row.tiporemolque = value;
            this.matchedValue++;
          } else if (keySource === 'placaremolque') {
            row.placaremolque = value;
            this.matchedValue++;
          } else if (keySource === 'tipoconductor') {
            this.cfdiCCP = true;
            row.tipoconductor = value;
            this.matchedValue++;
          } else if (keySource === 'rfcconductor') {
            this.cfdiCCP = true;
            row.rfcconductor = value;
            this.matchedValue++;
          } else if (keySource === 'numerolicenciadeconducir') {
            this.cfdiCCP = true;
            row.numerolicenciadeconducir = value;
            this.matchedValue++;
          }
        });
      }
      return dataExcel;
    },
    buildObservations(observation) {
      let value = '';
      const resource = observation[0];
      if (resource.placavehiculo) {
        value += `Placa vehículo: ${resource.placavehiculo}\n`;
      }
      if (resource.nombreconductor) {
        value += `Nombre conductor: ${resource.nombreconductor}\n`;
      }
      return value;
    },
    async generateCfdiIngreso() {
      const workbook = new ExcelJS.Workbook();

      // Crear hojas
      const generalData = workbook.addWorksheet('CFDI - Datos generales');
      const concept = workbook.addWorksheet('CFDI - Conceptos');
      const observations = workbook.addWorksheet('CFDI - Conductor y vehículo');

      generalData.columns = [
        { header: this.excelHeaders.serie, key: 'serie', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.folio, key: 'folio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.metododepago, key: 'metododepago', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.formadepago, key: 'formadepago', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalexpedicion, key: 'codigopostalexpedicion', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcemisor, key: 'rfcemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialemisor, key: 'razonsocialemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalemisor, key: 'regimenfiscalemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcreceptor, key: 'rfcreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialreceptor, key: 'razonsocialreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalreceptor, key: 'regimenfiscalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalreceptor, key: 'codigopostalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.usodelcfdi, key: 'usodelcfdi', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      generalData.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.serie') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.folio') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.metododepago') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.formadepago') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalexpedicion') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalemisor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('I1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('J1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('K1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('K1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalreceptor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('L1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('L1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('M1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('M1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.usodelcfdi') + '\n' + '\n' },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };

      concept.columns = [
        { header: this.excelHeaders.cantidad, key: 'cantidad', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigounidaddemedida, key: 'codigounidaddemedida', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigoproductooservicio, key: 'codigoproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.descripcionproductooservicio, key: 'descripcionproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.identificador, key: 'identificador', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.preciounitario, key: 'preciounitario', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.descuento, key: 'descuento', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.objetodeimpuesto, key: 'objetodeimpuesto', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.tipodeimpuesto, key: 'tipodeimpuesto', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.tasadeimpuesto, key: 'tasadeimpuesto', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      concept.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.cantidad') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('B1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigounidaddemedida') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogUnit') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigoproductooservicio') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogProduct') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.descripcionproductooservicio'),
          },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.identificador') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.preciounitario') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.descuento') + '\n' + '\n'},
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: '*Nota: Este descuento es el total aplicado a la suma de las unidades.' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.objetodeimpuesto') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('I1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.tipodeimpuesto') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('J1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.tasadeimpuesto') + '\n' },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: '*Por ejemplo: tasa de impuesto 0.06 para IVA 6%.' + '\n',
          },
        ],
        editAs: 'twoCells',
      };

      observations.columns = [
        { header: this.excelHeaders.placavehiculo, key: 'placavehiculo', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.nombreconductor, key: 'nombreconductor', width: 30, style: { numFmt: '@' } },
      ];
      observations.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.vehicle') },
        ],
        editAs: 'twoCells',
      };
      observations.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.driver') },
        ],
        editAs: 'twoCells',
      };

      generalData.addRow({
        serie: '',
        folio: '',
        metododepago: '',
        formadepago: '',
        codigopostalexpedicion: this.cfdi.issuer != null ? this.cfdi.issuer.PostalCode : '',
        rfcemisor: this.cfdi.issuer != null ? this.cfdi.issuer.Rfc : '',
        razonsocialemisor: this.cfdi.issuer != null ? this.cfdi.issuer.LegalName : '',
        regimenfiscalemisor:
          this.cfdi.issuer != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Name
            : '',
        rfcreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.Rfc : '',
        razonsocialreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.LegalName : '',
        regimenfiscalreceptor:
          this.cfdi.receiver != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Name
            : '',
        codigopostalreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.PostalCode : '',
        usodelcfdi:
          this.cfdi.receiver != null
            ? this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Value +
              ' - ' +
              this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Name
            : '',
      });

      for (let i = 0; i < this.taxRegimeList.length; i++) {
        generalData.getCell(`$XA$${i + 1}`).value = this.taxRegimeList[i].Value + ' - ' + this.taxRegimeList[i].Name;
      }

      for (let i = 0; i < this.cfdiUseList.length; i++) {
        generalData.getCell(`$XB$${i + 1}`).value = this.cfdiUseList[i].Value + ' - ' + this.cfdiUseList[i].Name;
      }

      for (let i = 0; i < this.paymentMethodList.length; i++) {
        generalData.getCell(`$XC$${i + 1}`).value =
          this.paymentMethodList[i].Value + ' - ' + this.paymentMethodList[i].Name;
      }

      for (let i = 0; i < this.paymentFormList.length; i++) {
        generalData.getCell(`$XD$${i + 1}`).value =
          this.paymentFormList[i].Value + ' - ' + this.paymentFormList[i].Name;
      }

      for (const trip of this.routeDetail.trips) {
        for (const activity of trip.activities) {
          for (const document of activity.documents) {
            for (const item of document.items) {
              console.log(item)
              const itemDataTemp = this.itemDataList.find((itemData) => itemData.id === item.idItemData);
              concept.addRow({
                cantidad: item.quantity,
                codigounidaddemedida: '',
                codigoproductooservicio: '',
                descripcionproductooservicio: item.name,
                identificador: itemDataTemp ? itemDataTemp.code : '',
                preciounitario: item.unitPrice ? String(item.unitPrice) : '',
              });
            }
          }
        }
      }

      for (let i = 0; i < this.taxObjectList.length; i++) {
        concept.getCell(`$XB$${i + 1}`).value = this.taxObjectList[i].Value + ' - ' + this.taxObjectList[i].Name;
      }

      generalData.getColumn(625).hidden = true; //XA
      generalData.getColumn(626).hidden = true; //XB
      generalData.getColumn(627).hidden = true; //XC
      generalData.getColumn(628).hidden = true; //XD
      concept.getColumn(626).hidden = true; //XB

      for (let i = 2; i < 200; i++) {
        generalData.getCell(`C${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XC$1:$XC$${this.paymentMethodList.length}`],
        };
        generalData.getCell(`D${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XD$1:$XD$${this.paymentFormList.length}`],
        };
        generalData.getCell(`H${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`K${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`M${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XB$1:$XB$${this.cfdiUseList.length}`],
        };
      }

      for (let i = 2; i < 200; i++) {
        concept.getCell(`H${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XB$1:$XB$${this.taxObjectList.length}`],
        };
        concept.getCell(`I${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['"IVA,IVA RET,ISR,IEPS"'], // nota las comillas dobles y la coma entre los valores
        };
      }

      for (const assignation of this.routeDetail.assignations) {
        observations.addRow({
          placavehiculo: assignation.vehicle ? assignation.vehicle.plate : '',
          nombreconductor: assignation.driver ? `${assignation.driver.firstName} ${assignation.driver.lastName}` : '',
        });
      }

      // Guardar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), 'cfdi_ingreso.xlsx');
    },
    async generateCfdiTrasladoCCartaPorte() {
      const workbook = new ExcelJS.Workbook();

      // Crear hojas
      const generalData = workbook.addWorksheet('CFDI - Datos generales');
      const concept = workbook.addWorksheet('CFDI - Conceptos');

      generalData.columns = [
        { header: this.excelHeaders.serie, key: 'serie', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.folio, key: 'folio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalexpedicion, key: 'codigopostalexpedicion', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcemisor, key: 'rfcemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialemisor, key: 'razonsocialemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalemisor, key: 'regimenfiscalemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcreceptor, key: 'rfcreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialreceptor, key: 'razonsocialreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalreceptor, key: 'regimenfiscalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalreceptor, key: 'codigopostalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.usodelcfdi, key: 'usodelcfdi', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      generalData.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.serie') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.folio') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalexpedicion') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalemisor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('I1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalreceptor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('J1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('K1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('K1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.usodelcfdi') + '\n' + '\n' },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };

      concept.columns = [
        { header: this.excelHeaders.cantidad, key: 'cantidad', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigounidaddemedida, key: 'codigounidaddemedida', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigoproductooservicio, key: 'codigoproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.descripcionproductooservicio, key: 'descripcionproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.identificador, key: 'identificador', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      concept.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.cantidad') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('B1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigounidaddemedida') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogUnit') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigoproductooservicio') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogProduct') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.descripcionproductooservicio'),
          },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.identificador') },
        ],
        editAs: 'twoCells',
      };

      generalData.addRow({
        serie: '',
        folio: '',
        codigopostalexpedicion: this.cfdi.issuer != null ? this.cfdi.issuer.PostalCode : '',
        rfcemisor: this.cfdi.issuer != null ? this.cfdi.issuer.Rfc : '',
        razonsocialemisor: this.cfdi.issuer != null ? this.cfdi.issuer.LegalName : '',
        regimenfiscalemisor:
          this.cfdi.issuer != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Name
            : '',
        rfcreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.Rfc : '',
        razonsocialreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.LegalName : '',
        regimenfiscalreceptor:
          this.cfdi.receiver != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Name
            : '',
        codigopostalreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.PostalCode : '',
        usodelcfdi:
          this.cfdi.receiver != null
            ? this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Value +
              ' - ' +
              this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Name
            : '',
      });

      for (const trip of this.routeDetail.trips) {
        for (const activity of trip.activities) {
          for (const document of activity.documents) {
            for (const item of document.items) {
              const itemDataTemp = this.itemDataList.find((itemData) => itemData.id === item.idItemData);
              concept.addRow({
                cantidad: item.quantity,
                codigounidaddemedida: '',
                codigoproductooservicio: '',
                descripcionproductooservicio: item.name,
                identificador: itemDataTemp ? itemDataTemp.code : '',
              });
            }
          }
        }
      }
      for (let i = 0; i < this.taxRegimeList.length; i++) {
        generalData.getCell(`$XA$${i + 1}`).value = this.taxRegimeList[i].Value + ' - ' + this.taxRegimeList[i].Name;
      }

      for (let i = 0; i < this.cfdiUseList.length; i++) {
        generalData.getCell(`$XB$${i + 1}`).value = this.cfdiUseList[i].Value + ' - ' + this.cfdiUseList[i].Name;
      }

      generalData.getColumn(625).hidden = true; //XA
      generalData.getColumn(626).hidden = true; //XB

      for (let i = 2; i < 200; i++) {
        generalData.getCell(`I${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`F${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`K${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XB$1:$XB$${this.cfdiUseList.length}`],
        };
      }

      // Guardar archivo
      const buffer = await this.CCPProcess(workbook);
      saveAs(new Blob([buffer]), 'cfdi_traslado_CCP.xlsx');
    },
    async generateCfdiIngresoCCartaPorte() {
      const workbook = new ExcelJS.Workbook();

      // Crear hojas
      const generalData = workbook.addWorksheet('CFDI - Datos generales');
      const concept = workbook.addWorksheet('CFDI - Conceptos');

      generalData.columns = [
        { header: this.excelHeaders.serie, key: 'serie', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.folio, key: 'folio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.metododepago, key: 'metododepago', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.formadepago, key: 'formadepago', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalexpedicion, key: 'codigopostalexpedicion', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcemisor, key: 'rfcemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialemisor, key: 'razonsocialemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalemisor, key: 'regimenfiscalemisor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcreceptor, key: 'rfcreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.razonsocialreceptor, key: 'razonsocialreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.regimenfiscalreceptor, key: 'regimenfiscalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostalreceptor, key: 'codigopostalreceptor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.usodelcfdi, key: 'usodelcfdi', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      generalData.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.serie') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.folio') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.metododepago') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.formadepago') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalexpedicion') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialemisor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalemisor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('I1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.rfcreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('J1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.razonsocialreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('K1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('K1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.regimenfiscalreceptor') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') + '\n' },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('L1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('L1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.codigopostalreceptor') },
        ],
        editAs: 'twoCells',
      };
      generalData.getCell('M1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      generalData.getCell('M1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.usodelcfdi') + '\n' + '\n' },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };

      concept.columns = [
        { header: this.excelHeaders.cantidad, key: 'cantidad', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigounidaddemedida, key: 'codigounidaddemedida', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigoproductooservicio, key: 'codigoproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.descripcionproductooservicio, key: 'descripcionproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.identificador, key: 'identificador', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.preciounitario, key: 'preciounitario', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.descuento, key: 'descuento', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.objetodeimpuesto, key: 'objetodeimpuesto', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.tipodeimpuesto, key: 'tipodeimpuesto', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.tasadeimpuesto, key: 'tasadeimpuesto', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      concept.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.cantidad') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('B1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigounidaddemedida') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogUnit') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.codigoproductooservicio') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.catalogProduct') + '\n' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.descripcionproductooservicio'),
          },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.identificador') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.preciounitario') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.descuento') + '\n' + '\n' },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: '*Nota: Este descuento es el total aplicado a la suma de las unidades.' },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.objetodeimpuesto') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('I1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: this.t('cfdi.excel.tipodeimpuesto') + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.selectFromList') },
        ],
        editAs: 'twoCells',
      };
      concept.getCell('J1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      concept.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.tasadeimpuesto') + '\n' },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: '*Por ejemplo: tasa de impuesto 0.06 para IVA 6%.' + '\n',
          },
        ],
        editAs: 'twoCells',
      };

      generalData.addRow({
        serie: '',
        folio: '',
        metododepago: '',
        formadepago: '',
        codigopostalexpedicion: this.cfdi.issuer != null ? this.cfdi.issuer.PostalCode : '',
        rfcemisor: this.cfdi.issuer != null ? this.cfdi.issuer.Rfc : '',
        razonsocialemisor: this.cfdi.issuer != null ? this.cfdi.issuer.LegalName : '',
        regimenfiscalemisor:
          this.cfdi.issuer != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.issuer.RegimenFiscal).Name
            : '',
        rfcreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.Rfc : '',
        razonsocialreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.LegalName : '',
        regimenfiscalreceptor:
          this.cfdi.receiver != null
            ? this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Value +
              ' - ' +
              this.taxRegimeList.find((taxRegime) => taxRegime.Value == this.cfdi.receiver.RegimenFiscal).Name
            : '',
        codigopostalreceptor: this.cfdi.receiver != null ? this.cfdi.receiver.PostalCode : '',
        usodelcfdi:
          this.cfdi.receiver != null
            ? this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Value +
              ' - ' +
              this.cfdiUseList.find((cfdiUse) => cfdiUse.Value == this.cfdi.receiver.CfdiUse).Name
            : '',
      });

      for (let i = 0; i < this.taxRegimeList.length; i++) {
        generalData.getCell(`$XA$${i + 1}`).value = this.taxRegimeList[i].Value + ' - ' + this.taxRegimeList[i].Name;
      }

      for (let i = 0; i < this.cfdiUseList.length; i++) {
        generalData.getCell(`$XB$${i + 1}`).value = this.cfdiUseList[i].Value + ' - ' + this.cfdiUseList[i].Name;
      }

      for (let i = 0; i < this.paymentMethodList.length; i++) {
        generalData.getCell(`$XC$${i + 1}`).value =
          this.paymentMethodList[i].Value + ' - ' + this.paymentMethodList[i].Name;
      }

      for (let i = 0; i < this.paymentFormList.length; i++) {
        generalData.getCell(`$XD$${i + 1}`).value =
          this.paymentFormList[i].Value + ' - ' + this.paymentFormList[i].Name;
      }

      for (const trip of this.routeDetail.trips) {
        for (const activity of trip.activities) {
          for (const document of activity.documents) {
            for (const item of document.items) {
              const itemDataTemp = this.itemDataList.find((itemData) => itemData.id === item.idItemData);
              concept.addRow({
                cantidad: item.quantity,
                codigounidaddemedida: '',
                codigoproductooservicio: '',
                descripcionproductooservicio: item.name,
                identificador: itemDataTemp ? itemDataTemp.code : '',
                preciounitario: item.unitPrice ? String(item.unitPrice) : '',
              });
            }
          }
        }
      }

      for (let i = 0; i < this.taxObjectList.length; i++) {
        concept.getCell(`$XB$${i + 1}`).value = this.taxObjectList[i].Value + ' - ' + this.taxObjectList[i].Name;
      }

      generalData.getColumn(625).hidden = true; //XA
      generalData.getColumn(626).hidden = true; //XB
      generalData.getColumn(627).hidden = true; //XC
      generalData.getColumn(628).hidden = true; //XD
      concept.getColumn(626).hidden = true; //XB

      for (let i = 2; i < 200; i++) {
        generalData.getCell(`C${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XC$1:$XC$${this.paymentMethodList.length}`],
        };
        generalData.getCell(`D${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XD$1:$XD$${this.paymentFormList.length}`],
        };
        generalData.getCell(`H${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`K${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XA$1:$XA$${this.taxRegimeList.length}`],
        };
        generalData.getCell(`M${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XB$1:$XB$${this.cfdiUseList.length}`],
        };
      }

      for (let i = 2; i < 200; i++) {
        concept.getCell(`H${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`$XB$1:$XB$${this.taxObjectList.length}`],
        };
        concept.getCell(`I${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['"IVA,IVA RET,ISR,IEPS"'], // nota las comillas dobles y la coma entre los valores
        };
      }

      // Guardar archivo
      const buffer = await this.CCPProcess(workbook);
      saveAs(new Blob([buffer]), 'cfdi_ingreso_CCP.xlsx');
    },
    async CCPProcess(workbook){
      const ubicaciones = workbook.addWorksheet('CCP - Ubicaciones');
      const mercancias = workbook.addWorksheet('CCP - Mercancías');
      const driverVehicle = workbook.addWorksheet('CCP - Vehículo y conductor');

      ubicaciones.columns = [
        { header: this.excelHeaders.tipoubicacion, key: 'tipoubicacion', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.idubicacion, key: 'idubicacion', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.nombreubicacion, key: 'nombreubicacion', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfc, key: 'rfc', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigopostal, key: 'codigopostal', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.calle, key: 'calle', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.numeroexterior, key: 'numeroexterior', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.numerointerior, key: 'numerointerior', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.localidad, key: 'localidad', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.colonia, key: 'colonia', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.municipioalcaldia, key: 'municipioalcaldia', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.estado, key: 'estado', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.fechadesalidallegada, key: 'fechadesalidallegada', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.horadesalidallegada, key: 'horadesalidallegada', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.distanciarecorrida, key: 'distanciarecorrida', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      ubicaciones.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Indicar si la ubicación es remitente o destinatario en este complemento carta porte.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe seleccionar un elemento de la lista.',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('B1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Indica un número identificador interno de la ubicación. El cliente debe escogerlo.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*El identificador no debe repetirse en este documento y tener una extensión máxima de 6 dígitos.',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: 'Nombre del remitente o destintario.' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, text: this.t('cfdi.excel.serie') },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'RFC del remitente o destinatario.',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código postal de la ubicación.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*El estado, municipio/alcaldía y localidad son calculados automáticamente en base al código postal.',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Nombre de la calle de la ubicación.',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Número exterior de la ubicación.',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Número interior de la ubicación.',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código de la localidad asociada a la ubicación.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "código localidad".',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.optional') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código de la colonia asociada a la ubicación.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "colonia 1", "colonia 2" o "colonia 3".',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('K1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('K1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código del municipio asociado a la ubicación.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Municipio-Alcaldía".',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('L1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('L1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código del estado asociado a la ubicación.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Estado".',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('M1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('M1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código del estado asociado a la ubicación.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Debe ingresarse en formato AAAA-MM-DD',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('N1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('N1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Hora de salida (para remiente) o llegada (para destinatarios).' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Debe ingresarse en formato HH:MM',
          },
        ],
        editAs: 'twoCells',
      };
      ubicaciones.getCell('O1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      ubicaciones.getCell('O1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: '(Se debe completar solo para destinatarios)' + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Distancia recorrida en kilómetros.',
          },
        ],
        editAs: 'twoCells',
      };

      mercancias.columns = [
        { header: this.excelHeaders.codigoproductooservicio, key: 'codigoproductooservicio', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.descripcionmercancia, key: 'descripcionmercancia', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.cantidad, key: 'cantidad', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigounidaddemedida, key: 'codigounidaddemedida', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.pesoenkg, key: 'pesoenkg', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.idorigen, key: 'idorigen', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.iddestino, key: 'iddestino', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.materialpeligroso, key: 'materialpeligroso', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.codigomaterialpeligroso, key: 'codigomaterialpeligroso', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.embalajematerialpeligroso, key: 'embalajematerialpeligroso', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      mercancias.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código del SAT asociado a la mercancía a ser transportada.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Producto-Servicio".',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('B1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Descripción de la mercancía a ser transportada.',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Cantidad a transportar de la mercancía.',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Unidad de medida de los productos, conceptos o partidas.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Unidad de medida".',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Peso en kg del total de mercancías.',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Identificador de la ubicación de origen de las mercancías.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Debe ingresarse el mismo ID registrado en la hoja "CCP - Ubicaciones".',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Identificador de la ubicación de destino de las mercancías.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Debe ingresarse el mismo ID registrado en la hoja "CCP - Ubicaciones".',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      mercancias.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Indica si la mercancía es considerada material peligroso.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe seleccionar un elemento de la lista.',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: '(Se debe completar si en "¿Material peligroso?" se marca "Sí")' + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Clave asociada al material peligroso.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Material peligroso".',
          },
        ],
        editAs: 'twoCells',
      };
      mercancias.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: '(Se debe completar si en "¿Material peligroso?" se marca "Sí")' + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Clave asociada al tipo de embalaje del material peligroso.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Embalaje material peligroso".',
          },
        ],
        editAs: 'twoCells',
      };

      driverVehicle.columns = [
        { header: this.excelHeaders.permisosct, key: 'permisosct', width: 30, style: { numFmt: '@' } },        
        { header: this.excelHeaders.numeropermisosct, key: 'numeropermisosct', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.configuracionvehicular, key: 'configuracionvehicular', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.pesobrutovehicularton, key: 'pesobrutovehicularton', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.placa, key: 'placa', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.ano, key: 'ano', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.nombreaseguradoracivil, key: 'nombreaseguradoracivil', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.numeropolizaaseguradoracivil, key: 'numeropolizaaseguradoracivil', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.tiporemolque, key: 'tiporemolque', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.placaremolque, key: 'placaremolque', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.tipoconductor, key: 'tipoconductor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.rfcconductor, key: 'rfcconductor', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.numerolicenciadeconducir, key: 'numerolicenciadeconducir', width: 30, style: { numFmt: '@' } },
        { header: this.excelHeaders.nombreconductor, key: 'nombreconductor', width: 30, style: { numFmt: '@' } },
        { width: 30 },
      ];

      driverVehicle.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('A1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Indica el permiso de la SCT que tiene el autotransporte.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Permiso SCT".',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('B1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('B1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Número del permiso de la SCT.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('C1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('C1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Código del tipo de configuración del vehículo autotransporte.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Configuración vehicular".',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('D1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('D1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Peso bruto (en toneladas) del vehículo de autotransporte.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('E1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('E1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Placa del vehículo.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('F1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('F1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Año del vehículo.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('G1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('G1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Nombre de la aseguradora de responsabilidad civil.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('H1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('H1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Número de póliza de la aseguradora de responsabilidad civil.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('I1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: '(Se debe completar si el vehículo lleva remolque asociado)' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Código del tipo de configuración del remolque.',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe ingresar según el catálogo en la hoja "Tipo remolque".',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('J1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: '(Se debe completar si el vehículo lleva remolque asociado)' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Placa del remolque.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('K1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('K1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          {
            font: { size: 12, name: 'Calibri', scheme: 'minor' },
            text: 'Tipo de conductor asociado al autotransporte.' + '\n' + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: '*Se debe seleccionar un elemento de la lista.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('L1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('L1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'RFC del conductor.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('M1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('M1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Número de licencia del operador y conductor.',
          },
        ],
        editAs: 'twoCells',
      };
      driverVehicle.getCell('N1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      driverVehicle.getCell('N1').note = {
        texts: [
          {
            font: { bold: true, size: 12, name: 'Calibri', family: 2, scheme: 'minor' },
            text: this.t('cfdi.excel.required') + '\n',
          },
          { font: { size: 12, name: 'Calibri', scheme: 'minor' }, 
            text: 'Nombre del conductor.',
          },
        ],
        editAs: 'twoCells',
      };
      
      let isFirstTrip = true;
      let index = 1;
      const tripsReversed = this.routeDetail.trips.reverse();
      //Se obtienen los codigos postales
      const codigosPostales = [];
      for (const trip of tripsReversed) {
        if (trip.destination.address.postalCode) {
          codigosPostales.push(trip.destination.address.postalCode);
        }
      }
      // Eliminar duplicados
      const codigosPostalesFiltrados = [...new Set(codigosPostales)];

      // Obtener dato de codigos postales
      const datoCodigosPostales = await this.obtainPostalCodeData(codigosPostalesFiltrados);

      let distanciaTotalRecorrida = 0;
      for (const trip of tripsReversed) {
        if (!isFirstTrip) {
          const fechaTermino = new Date(trip.endDate);
          fechaTermino.setSeconds(fechaTermino.getSeconds() - trip.duration);
          // Formato "AAAA-MM-DD"
          const fechaTerminoStr = moment(fechaTermino).format('YYYY/MM/DD');
          // Formato "HH:MM:SS"
          const horaTerminoStr = moment(fechaTermino).format('HH:mm');
          
          let result = null;
          if (trip.destination.address.postalCode){
            result = datoCodigosPostales.find(r => r.Value === trip.destination.address.postalCode);
          }
          distanciaTotalRecorrida += trip.drivingDistance
          ubicaciones.addRow({
            tipoubicacion: 'Destino',
            idubicacion: index++,
            nombreubicacion: trip.destination.name,
            codigopostal: trip.destination.address.postalCode ? trip.destination.address.postalCode : '',
            fechadesalidallegada: fechaTerminoStr,
            horadesalidallegada: horaTerminoStr,
            distanciarecorrida: distanciaTotalRecorrida > 0 ? distanciaTotalRecorrida / 1000 : 0,
            localidad: result ? result.LocationCode : "",
            municipioalcaldia: result ? result.MunicipalityCode : "",
            estado: result ? result.StateCode : "",
          });
        } else {
          isFirstTrip = false;

          const fechaInicio = new Date(trip.startDate);
          // Formato "AAAA-MM-DD"
          const fechaInicioStr = moment(fechaInicio).format('YYYY/MM/DD');
          // Formato "HH:MM:SS"
          const horaInicioStr = moment(fechaInicio).format('HH:mm');

          const fechaTermino = new Date(trip.endDate);
          fechaTermino.setSeconds(fechaTermino.getSeconds() - trip.duration);
          // Formato "AAAA-MM-DD"
          const fechaTerminoStr = moment(fechaTermino).format('YYYY/MM/DD');
          // Formato "HH:MM:SS"
          const horaTerminoStr = moment(fechaTermino).format('HH:mm');

          let result = null;
          if (trip.origin.address.postalCode){
            result = datoCodigosPostales.find(r => r.Value === trip.origin.address.postalCode);
          }
          ubicaciones.addRow({
            tipoubicacion: 'Origen',
            idubicacion: index++,
            nombreubicacion: trip.origin.name,
            codigopostal: trip.origin.address.postalCode ? trip.origin.address.postalCode : '',
            fechadesalidallegada: fechaInicioStr,
            horadesalidallegada: horaInicioStr,
            localidad: result ? result.LocationCode : "",
            municipioalcaldia: result ? result.MunicipalityCode : "",
            estado: result ? result.StateCode : "",
            distanciarecorrida: 0,
          });

          if (trip.destination.address.postalCode){
            result = datoCodigosPostales.find(r => r.Value === trip.destination.address.postalCode);
          }

          distanciaTotalRecorrida += trip.drivingDistance
          ubicaciones.addRow({
            tipoubicacion: 'Destino',
            idubicacion: index++,
            nombreubicacion: trip.destination ? trip.destination.name : "",
            codigopostal: trip.destination.address.postalCode ? trip.destination.address.postalCode : '',
            fechadesalidallegada: fechaTerminoStr,
            horadesalidallegada: horaTerminoStr,
            distanciarecorrida: distanciaTotalRecorrida > 0 ? distanciaTotalRecorrida / 1000 : 0,
            localidad: result ? result.LocationCode : "",
            municipioalcaldia: result ? result.MunicipalityCode : "",
            estado: result ? result.StateCode : "",
          });
        }
      }

      for (const trip of this.routeDetail.trips) {
        for (const activity of trip.activities) {
          for (const document of activity.documents) {
            for (const item of document.items) {
              //const itemDataTemp = this.itemDataList.find((itemData) => itemData.id === item.idItemData);
              mercancias.addRow({
                descripcionmercancia: item.name,
                cantidad: item.quantity
              });
            }
          }
        }
      }

      for (const assignation of this.routeDetail.assignations) {
        driverVehicle.addRow({
          placa: assignation.vehicle.plate ? assignation.vehicle.plate : '',
          ano: assignation.vehicle.year ? assignation.vehicle.year : '',
          rfcconductor: assignation.driver.legalNumber ? assignation.driver.legalNumber : '',
          numerolicenciadeconducir: assignation.driver.licenceNumber ? assignation.driver.licenceNumber : '',
          nombreconductor: `${assignation.driver.firstName} ${assignation.driver.lastName}`,
        });
      }

      for (let i = 2; i < 200; i++) {
        ubicaciones.getCell(`A${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"Origen,Destino"`],
        };
        mercancias.getCell(`H${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"Sí,No"`],
        };
        driverVehicle.getCell(`K${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"${this.catalogDriverType.map(item => item.Value).join(",")}"`],
        };
      }
      return await workbook.xlsx.writeBuffer();
    },
    async obtainPostalCodeData(codigosPostales) {
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            'x-api-key': store.getters.clientApiKey,
          },
        };

        const peticiones = codigosPostales.map(codigo =>
          axios.get(`https://api-dev.tranciti.com/carta-porte/PostalCode?keyword=${codigo}`, config)
            .then(res => ({ codigo, data: res.data }))
            .catch(() => ({ codigo, data: null }))
        );

        const resultados = await Promise.allSettled(peticiones);

        const respuestas = resultados
        .filter(r => r != null && r.value.data != null && r.value.data.data != null && r.value.data.data.length > 0) // Solo respuestas exitosas
        .map(r => r.value.data.data[0]); // Extrae el valor

        const datos = respuestas.map((r) => r);
        return datos;
      } catch (error) {
        console.error("Error en alguna de las peticiones:", error);
      }
      return [];
    },
    async addfile(event) {
      this.file = event.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        const data = new Uint8Array(this.arrayBuffer);
        const arr = new Array();
        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        const bstr = arr.join('');
        const workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });
        const first_sheet_name = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[first_sheet_name];
        this.generalDataExcel = XLSX.utils.sheet_to_json(worksheet, { raw: true });

        const second_sheet_name = workbook.SheetNames[1];
        const worksheet2nd = workbook.Sheets[second_sheet_name];
        this.conceptDataExcel = XLSX.utils.sheet_to_json(worksheet2nd, { raw: true });

        const third_sheet_name = workbook.SheetNames[2];
        const worksheet3nd = workbook.Sheets[third_sheet_name];
        this.locationsDataExcel = XLSX.utils.sheet_to_json(worksheet3nd, { raw: true });
        this.observations = XLSX.utils.sheet_to_json(worksheet3nd, { raw: true });

        const fourth_sheet_name = workbook.SheetNames[3];
        const worksheet4th = workbook.Sheets[fourth_sheet_name];
        this.merchDataExcel = XLSX.utils.sheet_to_json(worksheet4th, { raw: true });

        const fifth_sheet_name = workbook.SheetNames[4];
        const worksheet5th = workbook.Sheets[fifth_sheet_name];
        this.vehicleDriverDataExcel = XLSX.utils.sheet_to_json(worksheet5th, { raw: true });

        this.readFileExcel();
      };
    },
    async validateCfdiConcept() {
      if (this.bodyExcel === null) {
        return true;
      } else {
        if (this.bodyExcel.Items === undefined || this.bodyExcel.Items === null || this.bodyExcel.Items.length === 0) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.conceptRequired'));
        } else {
          for (const [index, item] of this.bodyExcel.Items.entries()) {
            const indexExcel = index + 2;
            if (
              item.Quantity === undefined ||
              isNaN(item.Quantity) ||
              item.Quantity === null ||
              item.Quantity === '' ||
              Array.isArray(item.Quantity)
            ) {
              this.errorMessageList.push(this.t('cfdi.errorMessage.quantityRequired', { index: indexExcel }));
            }
            if (item.UnitCode === undefined || item.UnitCode === null || item.UnitCode === '') {
              this.errorMessageList.push(this.t('cfdi.errorMessage.unitCodeRequired', { index: indexExcel }));
            }
            if (item.ProductCode === undefined || item.ProductCode === null || item.ProductCode === '') {
              this.errorMessageList.push(this.t('cfdi.errorMessage.productCodeRequired', { index: indexExcel }));
            }
            if (item.Description === undefined || item.Description === null || item.Description === '') {
              this.errorMessageList.push(this.t('cfdi.errorMessage.descriptionRequired', { index: indexExcel }));
            }

            if (this.bodyExcel.CfdiType === 'I') {
              if (item.UnitPrice === undefined || item.UnitPrice === null || item.UnitPrice === '') {
                this.errorMessageList.push(this.t('cfdi.errorMessage.unitPriceRequired', { index: indexExcel }));
              }
              if (item.Discount === undefined || item.Discount === null || item.Discount === '') {
                this.errorMessageList.push(this.t('cfdi.errorMessage.discountRequired', { index: indexExcel }));
              }
              if (item.TaxObject === undefined || item.TaxObject === null || item.TaxObject === '') {
                this.errorMessageList.push(this.t('cfdi.errorMessage.taxObjectRequired', { index: indexExcel }));
              } else {
                if (!this.taxObjectList.some((itemTemp) => itemTemp.Value == item.TaxObject)) {
                  this.errorMessageList.push(this.t('cfdi.errorMessage.taxObjectNotExist', { index: indexExcel }));
                }
              }
              //"IVA,IVA RET,ISR,IEPS"
              if (item.TaxObject == '02') {
                if (item.Taxes[0].Name === undefined || item.Taxes[0].Name === null || item.Taxes[0].Name === '') {
                  this.errorMessageList.push(this.t('cfdi.errorMessage.taxTypeRequired', { index: indexExcel }));
                } else {
                  if (
                    item.Taxes[0].Name !== 'IVA' &&
                    item.Taxes[0].Name !== 'IVA RET' &&
                    item.Taxes[0].Name !== 'ISR' &&
                    item.Taxes[0].Name !== 'IEPS'
                  ) {
                    this.errorMessageList.push(this.t('cfdi.errorMessage.taxTypeNotExist', { index: indexExcel }));
                  }
                }
                if (item.Taxes[0].Rate === undefined || item.Taxes[0].Rate === null || item.Taxes[0].Rate === '') {
                  this.errorMessageList.push(this.t('cfdi.errorMessage.taxRateRequired', { index: indexExcel }));
                }
              }
            }
          }
        }
      }
      if (this.errorMessageList.length > 0) {
        this.showCfdiValidateAlert = true;
        return false;
      }
      this.showCfdiValidateAlert = false;
      return true;
    },
    async validateCfdiGeneralData() {
      this.errorMessageList = [];
      this.showCfdiValidateAlert = false;
      if (this.bodyExcel === null) {
        this.errorMessageList.push(this.t('cfdi.errorMessage.noContent'));
      } else {
        if (this.bodyExcel.CfdiType === 'I') {
          if (
            this.bodyExcel.PaymentForm === undefined ||
            this.bodyExcel.PaymentForm === null ||
            this.bodyExcel.PaymentForm === ''
          ) {
            this.errorMessageList.push(this.t('cfdi.errorMessage.paymentFormRequired'));
          } else {
            if (!this.paymentFormList.some((item) => item.Value === this.bodyExcel.PaymentForm)) {
              this.errorMessageList.push(this.t('cfdi.errorMessage.paymentFormNotExist'));
            }
          }

          if (
            this.bodyExcel.PaymentMethod === undefined ||
            this.bodyExcel.PaymentMethod === null ||
            this.bodyExcel.PaymentMethod === ''
          ) {
            this.errorMessageList.push(this.t('cfdi.errorMessage.paymentMethodRequired'));
          } else {
            if (!this.paymentMethodList.some((item) => item.Value === this.bodyExcel.PaymentMethod)) {
              this.errorMessageList.push(this.t('cfdi.errorMessage.paymentMethodNotExist'));
            }
          }
        }

        if (
          this.bodyExcel.ExpeditionPlace === undefined ||
          isNaN(this.bodyExcel.ExpeditionPlace) ||
          this.bodyExcel.ExpeditionPlace === null ||
          this.bodyExcel.ExpeditionPlace === '' ||
          Array.isArray(this.bodyExcel.ExpeditionPlace)
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.expeditionPlace'));
        }
        if (
          this.bodyExcel.Issuer.Rfc === undefined ||
          this.bodyExcel.Issuer.Rfc === null ||
          this.bodyExcel.Issuer.Rfc === ''
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.rfcIssuerRequired'));
        }

        if (
          this.bodyExcel.Issuer.Name === undefined ||
          this.bodyExcel.Issuer.Name === null ||
          this.bodyExcel.Issuer.Name === ''
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.razonSocialIssuerRequired'));
        }

        if (
          this.bodyExcel.Issuer.FiscalRegime === undefined ||
          this.bodyExcel.Issuer.FiscalRegime === null ||
          this.bodyExcel.Issuer.FiscalRegime === ''
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.fiscalRegimeIssuerRequired'));
        } else {
          if (!this.taxRegimeList.some((item) => item.Value === this.bodyExcel.Issuer.FiscalRegime)) {
            this.errorMessageList.push(this.t('cfdi.errorMessage.fiscalRegimeIssuerNotExist'));
          }
        }

        if (
          this.bodyExcel.Receiver.Name === undefined ||
          this.bodyExcel.Receiver.Name === null ||
          this.bodyExcel.Receiver.Name === ''
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.razonSocialReceiverRequired'));
        }

        if (
          this.bodyExcel.Receiver.CfdiUse === undefined ||
          this.bodyExcel.Receiver.CfdiUse === null ||
          this.bodyExcel.Receiver.CfdiUse === ''
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.cfdiUseRequired'));
        } else {
          if (!this.cfdiUseList.some((item) => item.Value === this.bodyExcel.Receiver.CfdiUse)) {
            this.errorMessageList.push(this.t('cfdi.errorMessage.cfdiUseReceiverNotExist'));
          }
        }

        if (
          this.bodyExcel.Receiver.Rfc === undefined ||
          this.bodyExcel.Receiver.Rfc === null ||
          this.bodyExcel.Receiver.Rfc === ''
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.rfcReceiverRequired'));
        }

        if (
          this.bodyExcel.Receiver.FiscalRegime === undefined ||
          this.bodyExcel.Receiver.FiscalRegime === null ||
          this.bodyExcel.Receiver.FiscalRegime === ''
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.fiscalRegimeReceiverRequired'));
        } else {
          if (!this.taxRegimeList.some((item) => item.Value === this.bodyExcel.Receiver.FiscalRegime)) {
            this.errorMessageList.push(this.t('cfdi.errorMessage.fiscalRegimeReceiverNotExist'));
          }
        }

        if (
          this.bodyExcel.Receiver.TaxZipCode === undefined ||
          isNaN(this.bodyExcel.Receiver.TaxZipCode) ||
          this.bodyExcel.Receiver.TaxZipCode === null ||
          this.bodyExcel.Receiver.TaxZipCode === '' ||
          Array.isArray(this.bodyExcel.Receiver.TaxZipCode)
        ) {
          this.errorMessageList.push(this.t('cfdi.errorMessage.taxZipCodeReceiver'));
        }
      }
      if (this.errorMessageList.length > 0) {
        this.showCfdiValidateAlert = true;
        return false;
      }
      this.showCfdiValidateAlert = false;
      return true;
    },
    async validateCfdiLocations() {
      if (this.errorMessageList.length > 0) {
        this.showCfdiValidateAlert = true;
        return false;
      }
      this.showCfdiValidateAlert = false;
      return false;
    },
    async validateCfdiMerch() {
      if (this.errorMessageList.length > 0) {
        this.showCfdiValidateAlert = true;
        return false;
      }
      this.showCfdiValidateAlert = false;
      return false;
    },
    async validateCfdiVehicleDriver() {
      if (this.errorMessageList.length > 0) {
        this.showCfdiValidateAlert = true;
        return false;
      }
      this.showCfdiValidateAlert = false;
      return false;
    },
    async processCfdiFile() {
      if (this.file != null && this.matchedValue == 0) {
        this.invalidFileAlert = true;
        return null;
      }
      this.isCfdiGenerating = true;
      const resultGeneralData = await this.validateCfdiGeneralData();
      const resultConcept = await this.validateCfdiConcept();

      const resultLocations = true;
      const resultMerch = true;
      const resultVehicleDriver = true;
      /* if (this.cartaPorteEnabled) {
        resultLocations = await this.validateCfdiLocations();
        resultMerch = await this.validateCfdiMerch();
        resultVehicleDriver = await this.validateCfdiVehicleDriver();
      } */
      if (resultGeneralData && resultConcept && resultLocations && resultMerch && resultVehicleDriver) {
        await this.sendCfdi();
      }
      this.isCfdiGenerating = false;
    },
    async sendCfdi() {
      this.showCfdiSuccessAlert = false;
      this.loadingNewCfdi = true;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            'x-api-key': store.getters.clientApiKey,
          },
        };
        const url = `${store.getters.urlCartaPorte}/cfdi?idRoute=${this.routeDetail.id}`;

        //Reviso localidad si es CCP
        if ('Complemento' in this.bodyExcel) {
          const codigosPostales = [];
          for (let i = 0; i < this.bodyExcel.Complemento.CartaPorte31.Ubicaciones.length; i++) {
            //Se obtienen los codigos postales
            if (this.bodyExcel.Complemento.CartaPorte31.Ubicaciones[i].Domicilio.CodigoPostal != "" && this.bodyExcel.Complemento.CartaPorte31.Ubicaciones[i].Domicilio.Localidad == "") {
              codigosPostales.push(this.bodyExcel.Complemento.CartaPorte31.Ubicaciones[i].Domicilio.CodigoPostal);
            }
          }
          // Eliminar duplicados
          const codigosPostalesFiltrados = [...new Set(codigosPostales)];
          // Obtener dato de codigos postales
          const datoCodigosPostales = await this.obtainPostalCodeData(codigosPostalesFiltrados);
          
          for (let i = 0; i < this.bodyExcel.Complemento.CartaPorte31.Ubicaciones.length; i++) {
            if (this.bodyExcel.Complemento.CartaPorte31.Ubicaciones[i].Domicilio.CodigoPostal != "" && this.bodyExcel.Complemento.CartaPorte31.Ubicaciones[i].Domicilio.Localidad == "") {
              const result = datoCodigosPostales.find(r => r.Value === this.bodyExcel.Complemento.CartaPorte31.Ubicaciones[i].Domicilio.CodigoPostal);
              if (result) {
                this.bodyExcel.Complemento.CartaPorte31.Ubicaciones[i].Domicilio.Localidad = result.LocationCode;
              }
            } 
          }
        }

        await axios.post(url, this.bodyExcel, config);

        const [cfdis, stamps] = await Promise.all([this.getCfdiList(), this.getConfigClient()]);

        // 🔹 Asignar los valores una vez que todas las promesas se resuelvan
        this.cfdiList = cfdis;
        this.availableStamps = stamps;

        //Sincronizamos los cfdi creados para la ruta
        this.routeDetail.cfdiList = cfdis;
        this.route.cfdiList = cfdis;

        this.showCfdiSuccessAlert = true;

        this.logService.sendInfo({
          component: 'cfdiModal',
          message: `CFDI enviado por id client ${store.getters.clientId}`,
          data: this.bodyExcel,
        });
      } catch (e) {
        if (e.response) {
          try {
            this.errorMessageList = this.extractErrorMessages(e.response.data.message);
            this.showCfdiValidateAlert = true;
          } catch (error) {
            console.error('Error al parsear JSON:', error);
          }
        } else {
          console.log('Error desconocido:', e);
          this.errorMessageList = ['Ha ocurrido un error intentando procesar el CFDI.'];
          this.showCfdiValidateAlert = true;
        }
        this.showCfdiSuccessAlert = false;
      }
      this.loadingNewCfdi = false;
    },
    extractErrorMessages(errorString) {
      try {
        // Extraer la parte JSON del string
        const jsonMatch = errorString.match(/{.*}/);
        if (!jsonMatch) return [];

        const errorObj = JSON.parse(jsonMatch[0]);
        let messages = [];

        // Agregar el mensaje principal si existe
        if (errorObj.Message) {
          messages.push(errorObj.Message);
        }

        // Agregar los mensajes de ModelState si existen
        if (errorObj.ModelState) {
          Object.values(errorObj.ModelState).forEach((arr) => {
            messages = messages.concat(arr);
          });
        }

        return messages;
      } catch (error) {
        console.error('Error parsing JSON:', error);
        return [];
      }
    },
    async downloadCfdi(cfdi, documentType) {
      this.isDownloadingCfdi = cfdi.Id;
      this.activeDropdown = null;
      try {
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
            'x-api-key': store.getters.clientApiKey,
          },
        };
        const response = await axios.get(`${store.getters.urlCartaPorte}/cfdi/${documentType}/${cfdi.Id}`, config);
        let base64String = response.data.data;

        // Verifica si hay un prefijo "data:application/pdf;base64," y elimínalo
        if (base64String.includes(',')) {
          base64String = base64String.split(',')[1];
        }
        this.downloadBase64File(base64String, `${this.getCfdiName(cfdi)}.${documentType}`, documentType);
      } catch (e) {
        console.log(e);
      }
      this.isDownloadingCfdi = null;
    },
    downloadBase64File(base64String, fileName, documentType) {
      const byteCharacters = atob(base64String); // Decodifica Base64
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: `application/${documentType}` });

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getCfdiName(cfdi) {
      if (cfdi.Folio !== '' && cfdi.Serie !== '') {
        return cfdi.Serie + '_' + cfdi.Folio;
      }

      if (cfdi.Folio === '' && cfdi.Serie !== '') {
        return cfdi.Serie;
      }
      if (cfdi.Folio !== '' && cfdi.Serie === '') {
        return cfdi.Folio;
      }
      if (cfdi.Folio === '' && cfdi.Serie === '') {
        return this.route.id;
      }
    },
    downloadCatalogoSat() {
      const fileUrl = `${store.getters.urlCatalogoSat}`;
      return fileUrl;
    },
    checkCfdiDownload(cfdi) {
      if (this.isDownloadingCfdi !== null) {
        return this.isDownloadingCfdi == cfdi.Id;
      } else {
        return false;
      }
    },
    clearFile() {
      this.matchedValue == 0
      this.$refs.cfdi_file.value = '';
      this.file = null;
      this.bodyExcel = null;
      this.fileTypeAlert = false;
      this.invalidFileAlert = false;
      this.cfdiCCP = false;
      this.validationMessages = [];
    },
    toggleDropdown(index) {
      this.activeDropdown = this.activeDropdown === index ? null : index;
    },
    closeModal() {
      if (typeof this.onConfirmCallback === 'function') {
        this.onConfirmCallback(this.route);
      }
      this.$bvModal.hide('cfdi-handler-modal');
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      setTimeout(() => {
        this.$el.remove();
      }, 300);
    });
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      cfdi: cfdiEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      cfdi: cfdiEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      cfdi: cfdiEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      cfdi: cfdiEnus,
    });
  },
  watch: {
    cfdiType() {
      this.validateFileType();
    },
    cartaPorteEnabled() {
      this.validateFileType();
    },
  },
};
